const PER_PAGE = 50
const PAGE_COUNT = 0

const pageDefaults = {
  PER_PAGE,
  PAGE_COUNT,
}

export default pageDefaults
